export default __webpack_public_path__ + "madfit-screen-fourth@2x.d1efc03e.png";